export default __webpack_public_path__ + "ee72fa46a36d2c7ce5d4e35b6a7c40ea.png";